/** Wizard/API book language code → localized label for the current UI locale. */
export function bookLanguageDisplay(
  language: string | null | undefined,
  t: (key: string, vars?: Record<string, string | number>) => string
): string {
  if (language == null || language === "") return "";
  if (language === "Hebrew") return t("wizard.language.bookLanguageHebrew");
  if (language === "English") return t("wizard.language.bookLanguageEnglish");
  return language;
}
